<template>
	<div>
		<div class="mt-4 container-fluid">
			<div class="mt-4 ml-2 mb-4 d-flex justify-content-between">
				<div class="d-flex">
					<h1 class="h3 mb-0 text-gray-800">
						Cliente {{ dados.nome }}
					</h1>
				</div>
			    <div>
					<button 
						@click="update()"
						class="btn btn-primary mr-1">
						<i class="fas fa-edit"></i>
					</button>
					<button 
						@click="confirmDestroy()"
						class="btn btn-danger mr-1">
						<i class="fas fa-trash"></i>
					</button>
			    	<button 
				        @click="$router.go(-1)" 
				        class="btn btn-secondary">
			        	Voltar
			        </button>
			    </div>
			</div>
			<div class="card">
                <div class="card-header">
		        	<div class="d-flex justify-content-between container-fluid">
			            <div class="text-muted fs-19">
			            	<strong>Informações</strong>
			            </div>
			            
				    </div>
		        </div>
		        <div class="card-body">
		        	<div class="container">
			            <ul class="list-group">
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>Nome</strong>
								</div>
								<div>
									{{ dados.nome }}
								</div>
							</li>
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>C.P.F</strong>
								</div>
								<div>
									{{ dados.cpf }}
								</div>
							</li>
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>Data de Nascimento</strong>
								</div>
								<div>
									{{ dados.data_nascimento }}
								</div>
							</li>
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>C.E.P.</strong>
								</div>
								<div>
									{{ dados.cep }}
								</div>
							</li>
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>Bairro</strong>
								</div>
								<div>
									{{ dados.bairro }}
								</div>
							</li>
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>Cidade</strong>
								</div>
								<div>
									{{ dados.cidade }}
								</div>
							</li>
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>Estado</strong>
								</div>
								<div>
									{{ dados.estado }}
								</div>
							</li>
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>Logradouro</strong>
								</div>
								<div>
									{{ dados.logradouro }}
								</div>
							</li>
							<li class="list-group-item d-flex justify-content-between">
								<div>
									<strong>Complemento</strong>
								</div>
								<div>
									{{ dados.complemento }}
								</div>
							</li>
						</ul>
					</div>
		        </div>
		    </div>
		</div>

		<!-- Update -->
		<cliente-update
			@reload="getDados">
		</cliente-update>


		<!-- Confirmação para excluir -->
        <bsh-confirm 
        	modal_id="confirm_destroy_cliente" 
        	:dado_id="$route.params.id" 
        	title="Deseja realmente excluir este cliente?" 
        	btn="Excluir" 
        	btnStyle="btn-danger" 
        	method="delete" 
        	:rota="$url+'/api/adm/clientes/destroy/'" 
        	@reload="back()">
        </bsh-confirm>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				dados: []
			}
		},
		created(){
			this.getDados();
		},
		methods: {
			getDados(){
				axios.get(this.$url+'/api/adm/clientes/show/'+this.$route.params.id)
	            .then(response => {
	            	this.dados = response.data.data
	            })
	            .catch(error => {
	            	console.log(error)
	            });
			},
			update(){
				$('#update_cliente').modal('show');
			},
			confirmDestroy(){
				$('#confirm_destroy_cliente').modal('show');
			},
			back(){
				this.$router.go(-1)
			}
		}
	}
</script>